export default "__VITE_ASSET__302bb95e__"